import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from 'atoms/Button/Button';
import Card from 'atoms/Card/Card';
import FolderIcon from 'images/v5/3d/folder.png';
import MoveIcon from 'images/v5/icons/copy-07.svg';
import DotsIcon from 'images/v5/icons/dots-vertical.svg';
import EditSvg from 'images/v5/icons/edit-02.svg';
import FileSvg from 'images/v5/icons/file-04.svg';
import FolderSvg from 'images/v5/icons/folder.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import { openModal, selectLayout } from 'store/layoutSlice';
import { removeFolder, selectStatus } from 'store/specificationsFoldersSlice';
import { setCurrentFolder } from 'store/specificationsMoveSlice';
import ConfirmationModal from '../ConfirmationModal';
import styles from './FolderCard.module.scss';
function FolderCard({ folder: { id, name, foldersCount, modelSpecificationsCount, canBeRemoved, parentId }, link, layout, }) {
    var _a, _b, _c;
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const layoutState = useSelector(selectLayout);
    const status = useSelector(selectStatus);
    const folderLink = link || '/specifications/folders';
    const handleEdit = useCallback(() => {
        dispatch(openModal({ name: 'folderEditor', data: { id, name } }));
    }, [dispatch, id, name]);
    const handleMove = () => {
        dispatch(setCurrentFolder({ folderId: id }));
        dispatch(openModal({ name: 'moveFolder', data: { id } }));
    };
    const handleDelete = useCallback(() => {
        dispatch(removeFolder({ folderId: id, parentFolderId: parentId }));
    }, [dispatch, id, parentId]);
    const options = () => (React.createElement(React.Fragment, null,
        React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), onClick: handleEdit }, t('edit')),
        React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(MoveIcon, null), onClick: handleMove }, t('move')),
        React.createElement("hr", null),
        React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: () => dispatch(openModal({ name: 'removeFolder', id })) }, t('delete'))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { size: "s" }, layout === 'grid' ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.tools },
                React.createElement("div", { className: styles.labels },
                    React.createElement(FolderSvg, null),
                    foldersCount || 0,
                    React.createElement(FileSvg, null),
                    modelSpecificationsCount || 0),
                React.createElement("div", { className: styles.buttons }, canBeRemoved && (React.createElement(Dropdown, { trigger: React.createElement(Button, { theme: "ghost", size: "xs", shape: "rounded", leftIcon: React.createElement(DotsIcon, null) }) }, options())))),
            React.createElement(Link, { to: `${folderLink}/${id}`, className: styles.link },
                React.createElement("img", { src: FolderIcon, className: styles.icon, alt: "Folder" }),
                React.createElement("h3", { className: styles.header }, name)))) : (React.createElement("div", { className: styles.list },
            React.createElement(Link, { to: `${folderLink}/${id}` },
                React.createElement("img", { src: FolderIcon, className: styles.iconSmall, alt: "Folder" }),
                name || '-'),
            React.createElement("p", null,
                foldersCount || 0,
                " ",
                t('folder_plural')),
            React.createElement("p", null,
                modelSpecificationsCount || 0,
                " ",
                t('specification_plural')),
            React.createElement("p", null,
                React.createElement(Dropdown, { trigger: React.createElement(Button, { size: "xs", shape: "rounded", theme: "ghost", leftIcon: React.createElement(DotsIcon, null) }) }, options()))))),
        ((_a = layoutState.showModals) === null || _a === void 0 ? void 0 : _a.some((modal) => modal.name === 'removeFolder')) &&
            ((_c = (_b = layoutState.showModals) === null || _b === void 0 ? void 0 : _b.find((modal) => modal.name === 'removeFolder')) === null || _c === void 0 ? void 0 : _c.id) === id && (React.createElement(ConfirmationModal, { name: "removeFolder", header: React.createElement(React.Fragment, null,
                React.createElement(TrashSvg, null),
                t('REMOVE_FOLDER')), buttons: React.createElement(Button, { color: "danger", onClick: handleDelete }, t('common:delete')), action: handleDelete, loading: status.remove === 'loading' },
            React.createElement("h2", null, t('REMOVE_FOLDER_HEADER', { name })),
            React.createElement("p", null, t('REMOVE_FOLDER_MESSAGE'))))));
}
export default FolderCard;
